import { render, staticRenderFns } from "./tariffpage.vue?vue&type=template&id=11401382&"
import script from "./tariffpage.vue?vue&type=script&lang=js&"
export * from "./tariffpage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports